
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'reference',
  skipLLM: true,
  description: 'Find providers who have partnered with Plaid to provide account ownership verification'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Identity Partners' subtitle={metadata.description} mdxType="Header" />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Partner`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/identity/partnerships/alloy"
            }}>{`Alloy`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Offers identity data orchestration and credit decisioning to financial services companies looking to address fraud and uphold compliance (US only)`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The partners listed here include only those who provide an integration with Identity independently rather than as part of a money movement solution with Auth. For partners who use Plaid Identity as a complement to Plaid Auth, see `}<a parentName="p" {...{
        "href": "/docs/auth/partnerships"
      }}>{`Auth Partnerships`}</a>{`.`}</p>
    <p>{`For more information, see the list of partners in the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/integrations"
      }}>{`Plaid Dashboard`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
